
import {mapGetters} from 'vuex';

export default {
  name: 'schedule-row',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getPricesStatistic',
      'hasPrices',
    ]),
  },
  methods: {
    getPrices(day) {
      const date = `${day.year}-${day.month}-${day.day}`;
      const prices = this.hasPrices(this.item.fromCityCode, this.item.toCityCode) 
        ? this.getPricesStatistic(this.item.fromCityCode, this.item.toCityCode).prices || []
        : [];
      return prices.find(price => price?.date === date) || { price: null };
    },
  },
};
